import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAccountStore } from '../../components/Stores/accountStore';
import { useMaterialsStore } from '../../components/Stores/MaterialsStore';
import { useProduct } from '../../hooks/useProducts';
import { Product } from '../../sp-types/productType';
import { LoadingLogoComponent } from '../Quotes/LoadingLogoComponent';
import { AddNewProductScreen } from './AddNewProductComponents.tsx/AddNewProductScreen';
import { AddNewProductSummary } from './AddNewProductComponents.tsx/AddNewProductSummarySection';
import { NEW_PRODUCT_URL_PARAM } from './ProductDashboard/ProductDashboard';
import { emptyProduct, isProductValidToSave, ProductScreensType, saveProductOnDb } from './productUtils';

export const AddNewProduct = () => {
  const { account } = useAccountStore();
  const { productId } = useParams<{ productId: string }>();
  const { data: productData, refetch, isLoading: isLoadingProduct, isFetching } = useProduct(productId);
  const [editedProduct, setEditedProduct] = useState<Product>(emptyProduct); // Need to refetch this properly
  const [currentScreen, setCurrentScreen] = useState<ProductScreensType>('attachFiles');
  const [isLoading, setIsLoading] = useState(false);
  const { materialsMap } = useMaterialsStore();
  const navigate = useNavigate();

  useEffect(() => {
    const loadProductData = async () => {
      if (productId === NEW_PRODUCT_URL_PARAM) {
        setEditedProduct(emptyProduct); // New product scenario
        setCurrentScreen('attachFiles');
      } else {
        if (productData) {
          setEditedProduct(productData);
          setCurrentScreen('modifyProduct');
        }
      }
      setIsLoading(false);
    };
    loadProductData();
  }, [productId, productData, refetch]);

  return isLoading ? (
    <LoadingLogoComponent />
  ) : (
    <div className="flex flex-row flex-1  h-full  gap-4 overflow-hidden">
      <div className="flex flex-1 overflow-auto ">
        {isLoadingProduct && isFetching && <LoadingLogoComponent />}
        <AddNewProductScreen
          currentScreen={currentScreen}
          setCurrentScreen={setCurrentScreen}
          product={editedProduct}
          setProductDetails={setEditedProduct}
        />
      </div>
      {(editedProduct.filesUrl || []).length === 0 && (
        <div className="flex flex-0">
          <AddNewProductSummary
            isLoading={isLoading}
            isSubmitDisabled={!isProductValidToSave(editedProduct)}
            materialsMap={materialsMap}
            cancel={() => navigate('/dashboard')}
            product={editedProduct}
            submit={() => {
              account.id &&
                saveProductOnDb(
                  editedProduct,
                  account.id,
                  setIsLoading,
                  (uuid?: string) => uuid && navigate(`/products-dashboard/${uuid}`),
                );
            }}
          />
        </div>
      )}
    </div>
  );
};
